var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-body pb-1",class:_vm.convertingBlob && 'loading'},[(_vm.base64)?_c('img',{staticClass:"s-rounded img-responsive img-content",attrs:{"src":_vm.base64}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }